import { ReactElement, useRef, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IMethod } from '~/models/Method';
import { MethodService } from '~/services';
import { handleYupValidationError } from '~/utils';
import { MethodSchema } from '~/utils/schemas/MethodSchema';

import EditMethodForm from '../EditMethodForm';

import * as S from './styles';

interface IEditMethodParams {
  methodId: string;
}

function EditMethod(): ReactElement {
  const { setLoading } = useLoading();
  const { methodId } = useParams<IEditMethodParams>();
  const formRef = useRef<FormHandles>(null);
  const router = useHistory();

  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  const handleEditMethodSubmit = useCallback(
    async (data: IMethod) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const formattedPrinciple = data.method_principle
          ?.replaceAll(',', '&')
          .replaceAll(/&\s/g, '&');

        const formattedData = { ...data, method_principle: formattedPrinciple };

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await MethodSchema(data.series_number!).validate(formattedData, {
          abortEarly: false,
        });
        const result = await MethodService.editMethod(methodId, formattedData);
        if (result.status === 200) {
          toast.success('Método editado com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao editar o método!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Editar Método</S.Title>
        </S.Header>
        <EditMethodForm
          formName="edit-form"
          formRef={formRef}
          methodId={methodId}
          handleSubmit={handleEditMethodSubmit}
        />
        <S.Footer>
          <Button
            form="edit-form"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.Footer>
      </S.Container>
    </>
  );
}

export default EditMethod;
